module.exports = __webpack_public_path__ + "img/36.468b843c.png";